var listLook = {};
listLook.short = function () {
  var listLookShortCollpase = $('.section-list-look-short-interstellar .collapse');
  $(listLookShortCollpase).on('shown.bs.collapse', function () {
    var button = $(this).closest('.list-look-short-wrapper').find('.list-look-short-btn');
    var buttonText = button.data('readless');
    button.text(buttonText);
  });
  $(listLookShortCollpase).on('hidden.bs.collapse', function () {
    var button = $(this).closest('.list-look-short-wrapper').find('.list-look-short-btn');
    var buttonText = button.data('readmore');
    button.text(buttonText);
  });
};
listLook.big = function () {
  var ListLookBigShowChar = 400;
  if (matchMedia('screen and (max-width: 1023px)').matches) {
    ListLookBigShowChar = 10000;
  }
  var ListLookBigEllipsisText = '...';
  var ListLookBigContent = $('.js-list-look-big-content');
  $.each(ListLookBigContent, function () {
    var currentListLookBigContent = $(this);
    var ListLookBigContentSection = currentListLookBigContent.closest('.section-list-look-big-interstellar');
    var ListLookBigContentPreview = currentListLookBigContent.find('.js-list-look-big-preview');
    var ListLookBigContentOther = currentListLookBigContent.find('.js-list-look-big-other');
    var ListLookBigContentEditor = currentListLookBigContent.find('.js-list-look-big-editor');
    var ListLookBigContentOLinks = currentListLookBigContent.find('.js-list-look-big-links');
    var ListLookBigContentCollapse = currentListLookBigContent.find('.collapse');
    var ListLookBigReadMoreText = currentListLookBigContent.data('readmore');
    var ListLookBigReadLessButton = currentListLookBigContent.find('.js-readLess-link');
    var content = ListLookBigContentPreview.find('.js-list-look-big-preview-content').html();
    if (ListLookBigContentEditor.length === 0) {
      ListLookBigContentCollapse.collapse({
        toggle: true
      });
      return;
    }
    if (content && content.length < ListLookBigShowChar) {
      currentListLookBigContent.addClass('has-no-content-hidden');
    }
    var currentShortListBigShownContent = content.substr(0, ListLookBigShowChar);
    var currentShortListBigHiddenContent = content.substr(ListLookBigShowChar - 1, content.length - ListLookBigShowChar);
    var currentShortListBigNewContent = currentShortListBigShownContent + '<span class="ellipsis">' + ListLookBigEllipsisText + '</span><span class="hidden-content"><span class="hidden-content-text d-none">' + currentShortListBigHiddenContent + '</span><button class="js-readMore-link btn btn-read btn-read-black">' + ListLookBigReadMoreText + '</button></span>';
    ListLookBigContentPreview.find('.js-list-look-big-preview-content').html(currentShortListBigNewContent);
    ListLookBigContentCollapse.collapse({
      toggle: false
    });
    var ListLookBigReadMoreButton = currentListLookBigContent.find('.js-readMore-link');
    ListLookBigReadMoreButton.click(function () {
      var _this = $(this);
      listLook.buttonClick(_this);

      // Show other content
      ListLookBigContentCollapse.collapse('toggle');

      // Show read less button
      ListLookBigReadLessButton.toggleClass('d-none');
      return false;
    });
    ListLookBigReadLessButton.click(function () {
      var _this = $(this);

      // Show other content
      ListLookBigContentCollapse.collapse('toggle');
      setTimeout(function () {
        listLook.buttonClick(_this);

        // Show read more button
        ListLookBigReadMoreButton.toggleClass('d-none');

        // Scroll to section after close
        $([document.documentElement, document.body]).animate({
          scrollTop: ListLookBigContentSection.offset().top
        }, 1000);
      }, 1000);
    });
  });
};
listLook.buttonClick = function (el) {
  // Hide
  el.addClass('d-none');

  // Toggle 3 dots
  el.closest('.js-list-look-big-content').find('.ellipsis').toggleClass('d-none');

  // Toggle hidden content
  el.closest('.js-list-look-big-content').find('.hidden-content-text').toggleClass('d-none');
};
listLook.init = function () {
  listLook.short();
  listLook.big();
};
listLook.init();


// WEBPACK FOOTER //
// ./scripts/components/interstellar/list-look.js